import { Organization } from "../organization/organization.model";

export enum GPSUnit {
  LAT_LON = 'LAT_LON',
  UTM = 'UTM',
}

export interface Account {
  id: string;
  firstName: string;
  lastName: string;
  phone: string;
  callSign?: string;
  country?: string;
  email: string;
  unit?: string;
  roles: string[];
  organizationId?: string;
  organization: Organization;
  gpsUnit?: GPSUnit;
  language?: string;
}
